import Vue from "vue";

Object.defineProperty(Vue.prototype, "$platformSettings", {
  get() {
    return (key) => {
      // Parametreyi Vuex getter'ına gönderip sonucu döndürüyor
      return this.$store.getters[
        "platformSettingsStore/getPlatformSettingByKey"
      ](key);
    };
  },
});
